module.exports = __webpack_public_path__ + "img/reasonableFees1x.7b6cf1af.png";